import {
  Box, HStack, IconButton, Text, Tooltip
} from '@chakra-ui/react'
import { FiMic, FiShare2, FiXCircle, FiBarChart2, FiMaximize } from 'react-icons/fi'

interface TopBarProps {
  transcript: string
  error: string | null
  onOpenMicSettings: () => void
  onOpenQRModal: () => void
  onOpenExitModal: () => void
  onOpenStatistics: () => void
  onToggleFullscreen: () => void
}

export function TopBar({
  transcript,
  error,
  onOpenMicSettings,
  onOpenQRModal,
  onOpenExitModal,
  onOpenStatistics,
  onToggleFullscreen
}: TopBarProps) {
  return (
    <Box w="100%" px={4}>
      <HStack justify="space-between" align="center">
        <Text
          fontSize="sm"
          color={error ? 'red.400' : 'gray.400'}
          fontWeight={error ? 'bold' : 'normal'}
          minH="20px"
          noOfLines={1}
          flex={1}
          textAlign="left"
        >
          {error || transcript || 'Listening...'}
        </Text>

        <HStack spacing={2} justify="center" flex={1}>
          <IconButton
            aria-label="Microphone Settings"
            icon={<FiMic />}
            onClick={onOpenMicSettings}
            variant="ghost"
            size="md"
            color="white"
            border={error ? "2px solid" : "none"}
            borderColor={error ? "red.400" : "transparent"}
          />



          <IconButton
            aria-label="Share QR"
            icon={<FiShare2 />}
            onClick={onOpenQRModal}
            variant="ghost"
            size="md"
            color="white"
          />

          <IconButton
            aria-label="Statistics"
            icon={<FiBarChart2 />}
            onClick={onOpenStatistics}
            variant="ghost"
            size="md"
            color="white"
          />

          <IconButton
            aria-label="Toggle Fullscreen"
            icon={<FiMaximize />}
            onClick={onToggleFullscreen}
            variant="ghost"
            size="md"
            color="white"
          />
        </HStack>

        <Box flex={1} display="flex" justifyContent="flex-end">
          <IconButton
            aria-label="Exit Match"
            icon={<FiXCircle />}
            onClick={onOpenExitModal}
            variant="ghost"
            size="md"
            color="white"
          />
        </Box>
      </HStack>
    </Box>
  )
} 